var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","placeholder":_vm.description},model:{value:(_vm.rawValue),callback:function ($$v) {_vm.rawValue=$$v},expression:"rawValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }